import { hydrateRoot } from "react-dom/client";

export const replaceHydrateFunction = () => (element, container, callback) => {
  hydrateRoot(container, element);
  if (typeof callback === "function") {
    callback();
  }
};
